import React, { useState, useEffect } from "react";
import {
  Divider,
  IconButton,
  Stack,
  Box,
  Typography,
  Link,
} from "@mui/material";
import { Phone, Email } from "@mui/icons-material";

export const DesktopAppbar = ({ func, translate, pages }) => {
  const [active, setActive] = useState(`${pages[0]}`);

  const handleChangeLanguage = (lang) => {
    // setLanguage(lang);
    func(lang);
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY < 200) {
        setActive(`${pages[0]}`);
      } else if (window.scrollY >= 200 && window.scrollY < 800) {
        setActive(`${pages[1]}`);
      } else if (window.scrollY >= 800 && window.scrollY < 2800) {
        setActive(`${pages[2]}`);
      } else {
        setActive(`${pages[3]}`);
      }
    });
  }, [active]);

  return (
    <Stack direction="row" spacing={3}>
      <Box
        flex={3}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
        }}
        padding={1}
      >
        <img
          src="/images/SBP_CONLogo_trans.png"
          alt="logo company"
          width="100vh"
          height="100vh"
        />
      </Box>
      <Box flex={5} color="white">
        <Box
          sx={{
            display: "flex",
            "& hr": {
              mx: 1,
            },
          }}
          padding={1}
        >
          <Link
            href="mailto:sale@sbpcon.co.th"
            underline="none"
            color="white"
            display="flex"
            alignItems="center"
            sx={{
              "&:hover": {
                color: "#669944",
              },
            }}
          >
            <Email style={{ marginRight: "5px" }} size="small" />
            <Typography>{translate("SALE_EMAIL")}</Typography>
          </Link>
          <Divider
            orientation="vertical"
            flexItem
            sx={{ border: "1px solid #669944" }}
          />
          <Link
            href="tel:0986264569"
            underline="none"
            color="white"
            display="flex"
            alignItems="center"
            sx={{
              "&:hover": {
                color: "#669944",
              },
            }}
          >
            <Stack direction="row">
              <Phone style={{ marginRight: "5px" }} size="small" />
              <Typography>{translate("SALE_PHONE")}</Typography>
            </Stack>
          </Link>
        </Box>
        <Stack direction="row" spacing={{ md: 1, lg: 3 }} p={{ md: 1, lg: 3 }}>
          {pages.map((page) => (
            <Link
              key={page}
              href={`#${page}`}
              sx={{
                color: `${page}` === active ? "#669944" : "white",
              }}
              onClick={() => setActive(page)}
              underline="none"
            >
              {translate(`${page}`)}
            </Link>
          ))}
        </Stack>
      </Box>
      <Box flex={4} color="white">
        <Box sx={{ display: "flex" }}>
          <IconButton
            size="large"
            color="inherit"
            aria-label="menu"
            style={{
              display: "flex",
              justifyContent: "center",
            }}
            onClick={() => handleChangeLanguage("th")}
          >
            <img
              src="/images/thailand.png"
              alt="Thailand Language"
              width={25}
              height={20}
            />
          </IconButton>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{ border: "1px solid #669944" }}
          />
          <IconButton
            size="large"
            color="inherit"
            aria-label="menu"
            onClick={() => handleChangeLanguage("en")}
          >
            <img
              src="/images/united-kingdom.png"
              alt="Thailand Language"
              width={25}
              height={20}
            />
          </IconButton>
        </Box>
      </Box>
    </Stack>
  );
};
